/* eslint-disable max-len */
/**
 * Awvent - OpenAIConnector API
 * Awvent OpenAIConnector Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpResponse,
    HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

import { AgentType } from '../model/agentType';
import { BooleanWebApiResponse } from '../../../common/models/booleanWebApiResponse';
import { MessageCreateCommand } from '../model/messageCreateCommand';
import { MessageDtoListWebApiPagedResponse } from '../model/messageDtoListWebApiPagedResponse';
import { MessageDtoListWebApiResponse } from '../model/messageDtoListWebApiResponse';
import { ThreadDtoWebApiResponse } from '../model/threadDtoWebApiResponse';
import { ThreadUpdateCommand } from '../model/threadUpdateCommand';

import { Configuration } from '../../../../configuration';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';
import { BASE_PATH } from '../../../../variables';
import {
    KBMessageCreateCommand,
    KBMessageDtoListWebApiResponse,
    MessageDtoIListWebApiPagedResponse,
} from '../model/models';

@Injectable()
export class MessageService {
    protected basePath = environment.api.openaiConnector;
        
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public messageActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public messageActivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public messageActivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling messageActivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messageActivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Message/Activate/${encodeURIComponent(
                String(id)
            )}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public messageDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public messageDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public messageDeactivateIdPut(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling messageDeactivateIdPut.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messageDeactivateIdPut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Message/Deactivate/${encodeURIComponent(
                String(id)
            )}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param tenantId
     * @param productId
     * @param threadType
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageGet(
        xTenantId: string,
        tenantId?: string,
        productId?: string,
        threadType?: AgentType,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<MessageDtoIListWebApiPagedResponse>;
    public messageGet(
        xTenantId: string,
        tenantId?: string,
        productId?: string,
        threadType?: AgentType,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<MessageDtoIListWebApiPagedResponse>>;
    public messageGet(
        xTenantId: string,
        tenantId?: string,
        productId?: string,
        threadType?: AgentType,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<MessageDtoIListWebApiPagedResponse>>;
    public messageGet(
        xTenantId: string,
        tenantId?: string,
        productId?: string,
        threadType?: AgentType,
        isActive?: boolean,
        orderBy?: Array<string>,
        isOrderByDescending?: boolean,
        searchText?: string,
        pageNumber?: number,
        pageSize?: number,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messageGet.'
            );
        }

        let queryParameters = new HttpParams({
            encoder: new CustomHttpUrlEncodingCodec(),
        });
        if (tenantId !== undefined && tenantId !== null) {
            queryParameters = queryParameters.set('TenantId', <any>tenantId);
        }
        if (productId !== undefined && productId !== null) {
            queryParameters = queryParameters.set('ProductId', <any>productId);
        }
        if (threadType !== undefined && threadType !== null) {
            queryParameters = queryParameters.set(
                'ThreadType',
                <any>threadType
            );
        }
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', <any>isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append(
                    'OrderBy',
                    <any>element
                );
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set(
                'IsOrderByDescending',
                <any>isOrderByDescending
            );
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set(
                'SearchText',
                <any>searchText
            );
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set(
                'PageNumber',
                <any>pageNumber
            );
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<MessageDtoIListWebApiPagedResponse>(
            'get',
            `${this.basePath}/Message`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<BooleanWebApiResponse>;
    public messageIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<BooleanWebApiResponse>>;
    public messageIdDelete(
        id: string,
        xTenantId: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<BooleanWebApiResponse>>;
    public messageIdDelete(
        id: string,
        xTenantId: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error(
                'Required parameter id was null or undefined when calling messageIdDelete.'
            );
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messageIdDelete.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<BooleanWebApiResponse>(
            'delete',
            `${this.basePath}/Message/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messageKnowledgeBasePost(
        xTenantId: string,
        body?: KBMessageCreateCommand,
        xRequestId?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<KBMessageDtoListWebApiResponse>;
    public messageKnowledgeBasePost(
        xTenantId: string,
        body?: KBMessageCreateCommand,
        xRequestId?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<KBMessageDtoListWebApiResponse>>;
    public messageKnowledgeBasePost(
        xTenantId: string,
        body?: KBMessageCreateCommand,
        xRequestId?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<KBMessageDtoListWebApiResponse>>;
    public messageKnowledgeBasePost(
        xTenantId: string,
        body?: KBMessageCreateCommand,
        xRequestId?: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messageKnowledgeBasePost.'
            );
        }

        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<KBMessageDtoListWebApiResponse>(
            'post',
            `${this.basePath}/Message/KnowledgeBase`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePost(
        xTenantId: string,
        body?: MessageCreateCommand,
        xRequestId?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<MessageDtoListWebApiResponse>;
    public messagePost(
        xTenantId: string,
        body?: MessageCreateCommand,
        xRequestId?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<MessageDtoListWebApiResponse>>;
    public messagePost(
        xTenantId: string,
        body?: MessageCreateCommand,
        xRequestId?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<MessageDtoListWebApiResponse>>;
    public messagePost(
        xTenantId: string,
        body?: MessageCreateCommand,
        xRequestId?: string,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messagePost.'
            );
        }

        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MessageDtoListWebApiResponse>(
            'post',
            `${this.basePath}/Message`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public messagePut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<ThreadDtoWebApiResponse>;
    public messagePut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<ThreadDtoWebApiResponse>>;
    public messagePut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<ThreadDtoWebApiResponse>>;
    public messagePut(
        xTenantId: string,
        body?: ThreadUpdateCommand,
        observe: any = 'body',
        reportProgress: boolean = false
    ): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error(
                'Required parameter xTenantId was null or undefined when calling messagePut.'
            );
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken =
                typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json',
        ];
        const httpHeaderAcceptSelected: string | undefined =
            this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json',
        ];
        const httpContentTypeSelected: string | undefined =
            this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ThreadDtoWebApiResponse>(
            'put',
            `${this.basePath}/Message`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }
}
